module.exports = __webpack_public_path__ + "static/media/kiran.693364a2.jpg";